<nz-cascader [nzOptions]="options" [(ngModel)]="postCascaderValue" [nzShowSearch]="true" [nzAllowClear]="true"
	(ngModelChange)="onPostCascaderValueChange()"></nz-cascader>